module.exports = __webpack_public_path__ + "static/erevan_ilesere-symbol-DND3_FnP-14f54f7a530a42d70f3fff2c66547fd9.webp";